import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import { Fade } from 'react-reveal'

const EmergencyTrades = ({title, items}) => {

  return (
    <section className='upcoming upcoming__auction upcoming--trades'>
      <Fade bottom distance='40px'>
        <div className='upcoming__inner'>
          <div className='upcoming__heading'>
            { title && <h1>{parse(title)}</h1> }
          </div>
          <div className='upcoming__table'>
            { items?.length && items.map((el, i) => {
              return (
                <div className='upcoming__item' key={i}>
                  <div className='upcoming__image'>
                    { el.image?.localFile && <GatsbyImage image={el.image.localFile.childImageSharp.gatsbyImageData} alt={el.title} /> }
                  </div>
                  <div className='upcoming__wrapper'>
                    <div>
                      { el.title && <h4>{ parse(el.title) }</h4> }
                      { el.content && <div>{ parse(el.content) }</div> }
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default EmergencyTrades
